var _rect, _rect2, _rect3, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdtech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.3785,
    y: 19.2764,
    width: 9.1215,
    height: 2.28037,
    rx: 1.14019,
    fill: "#9EBAF2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3785,
    y: 13.7285,
    width: 9.1215,
    height: 2.28037,
    rx: 1.14019,
    transform: "rotate(-30 32.3785 13.7285)",
    fill: "#9EBAF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.519,
    y: 24.9781,
    width: 9.12149,
    height: 2.28037,
    rx: 1.14019,
    transform: "rotate(30 33.519 24.9781)",
    fill: "#9EBAF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 17.6544C6.5 17.4223 6.63924 17.2128 6.85327 17.1229L12.3333 14.8214V26.5952L6.85327 24.2938C6.63924 24.2039 6.5 23.9944 6.5 23.7622V17.6544ZM14.2777 27.4119L27.4442 32.9415C28.2042 33.2607 29.1545 32.8618 29.1545 32.2231V9.19314C29.1545 8.55489 28.2042 8.15599 27.4442 8.47511L14.2777 14.0048V27.4119Z",
    fill: "#C9DBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0933 28.5276C11.0933 28.1786 11.4417 27.937 11.7685 28.0593L15.1922 29.3404C15.3876 29.4135 15.517 29.6001 15.517 29.8087V39.1367C15.517 39.4128 15.2932 39.6367 15.017 39.6367H11.5933C11.3171 39.6367 11.0933 39.4128 11.0933 39.1367V28.5276Z",
    fill: "#C9DBFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdtech);
export default __webpack_public_path__ + "static/media/adtech.de4e9057.svg";
export { ForwardRef as ReactComponent };